import Pin from "src/design-system/icons/Pin.svg?react";
import City from "src/design-system/icons/City.svg?react";
import Globe from "src/design-system/icons/Globe.svg?react";
import Plane from "src/design-system/icons/transit/Plane.svg?react";
import Train from "src/design-system/icons/transit/Train.svg?react";
import { tw } from "src/design-system/tw";

type IconProps = {
  kind: string;
  className?: string;
};

export function AutocompleteIcon({ kind, className }: IconProps) {
  switch (kind) {
    case "city":
    case "capital":
    case "town":
    case "village":
      return (
        <City
          title="building"
          className={tw("h-5 w-5 shrink-0 text-icon-primary", className)}
        />
      );
    case "airport":
      return (
        <Plane
          title="plane"
          className={tw("h-5 w-5 shrink-0 text-icon-primary", className)}
        />
      );
    case "station":
      return (
        <Train
          title="train"
          className={tw("h-5 w-5 shrink-0 text-icon-primary", className)}
        />
      );
    case "country":
      return (
        <Globe
          title="globe"
          className={tw("h-5 w-5 shrink-0 text-icon-primary", className)}
        />
      );
    default:
      return (
        <Pin
          title="pin"
          className={tw("h-5 w-5 shrink-0 text-icon-primary", className)}
        />
      );
  }
}
